import React from 'react';

import { FieldValues } from 'react-hook-form';

import { OhsFormSettings } from 'global-components/form/services/OhsFormModels';
import OhsMultipleSelectField from 'global-components/form/fields/OhsMultipleSelectField';
import { OhsSelectOption } from 'user/OhsUserModels';
import { OhsTitleCategory } from 'user/configurations/OhsModuleCategory';

interface Props {
  id: string;
  ohsFormSettings: OhsFormSettings<FieldValues>;
  options: OhsTitleCategory[];
}
export default function OhsResidualRiskMultSelectFilter(props: Props) {
  const riskLists: OhsSelectOption[] =
    props.options.map((risk) => ({
      name: risk.title,
      value: risk.title,
    })) ?? [];

  return (
    <div>
      <OhsMultipleSelectField
        title="Risk Rating"
        id={props.id}
        required={false}
        options={riskLists}
        ohsFormSettings={props.ohsFormSettings}
      />
    </div>
  );
}
